/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_R_DocsInputs */

const en_mk_cmp_r_docs = /** @type {(inputs: Mk_Cmp_R_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Docs & wiki`)
};

const id_mk_cmp_r_docs = /** @type {(inputs: Mk_Cmp_R_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumen & wiki`)
};

/**
* | output |
* | --- |
* | "Docs & wiki" |
*
* @param {Mk_Cmp_R_DocsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_r_docs = /** @type {((inputs?: Mk_Cmp_R_DocsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_R_DocsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_r_docs(inputs)
	return en_mk_cmp_r_docs(inputs)
});